import { render, staticRenderFns } from "./SnippetEditor.vue?vue&type=template&id=664bf654&scoped=true&"
import script from "./SnippetEditor.vue?vue&type=script&lang=js&"
export * from "./SnippetEditor.vue?vue&type=script&lang=js&"
import style0 from "./SnippetEditor.vue?vue&type=style&index=0&id=664bf654&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664bf654",
  null
  
)

export default component.exports